import React, { useEffect, useState } from "react";
import Link from "next/link";
import { useDispatch, useSelector } from "react-redux";
import { setInquiryPopup } from "@/store/slices/inquirySlice";
import { usePathname } from "next/navigation";

const BottomStrip = ({
  // isAmenityActive,
  isMobilescreen,
  projects_full_list_detail,
}) => {
  const dispatch = useDispatch();
  const inquiryPopup = useSelector((state) => state.inquiry.inquiryPopup);
  const isAmenityActive = useSelector((state) => state.inquiry.isAmenityOpen);
  const isProximityActive = useSelector((state) => state.inquiry.isProximityOpen);
  const [showStrip, setShowStrip] = useState(false);
  const [fixedBtnActive, setFixedBtnActive] = useState(false);
  const pathName = usePathname();
  const excludedPaths = [
    "/",
    "/projects",
    "/career",
    "/contact-us",
    "/about-us",
    "/channelpartner",
  ];
  const isThankYouPage = pathName?.includes("/thankyou");
  const shouldEnableScrollEffect =
    !excludedPaths.includes(pathName) && !isThankYouPage;

  const hideStrip = isProximityActive || isAmenityActive || inquiryPopup;

  useEffect(() => {
    if (!shouldEnableScrollEffect) return;

    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const remainingDistance = documentHeight - (scrollTop + windowHeight);

      if (scrollTop > 600 && remainingDistance > 600) {
        setShowStrip(true);
        setFixedBtnActive(true);
      } else if (scrollTop < 200) {
        setShowStrip(false);
        setFixedBtnActive(false);
      } else if (remainingDistance >= 600) {
        setTimeout(() => {
          setShowStrip(true);
          setFixedBtnActive(true);
        }, 100);
      }

      if (remainingDistance < 600 || scrollTop < 600) {
        setTimeout(() => {
          setShowStrip(false);
          setFixedBtnActive(false);
        }, 100);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [shouldEnableScrollEffect]);

  const onInquireClick = () => {
    dispatch(setInquiryPopup(true));
  };

  // useEffect(() => {
  //   console.log(isAminities);
  // }, [isAminities]);

  // if (!projects_full_list_detail) return null;

  return (
    <>
      {projects_full_list_detail &&
        pathName != "/" &&
        pathName != "/projects" &&
        pathName != "/career" &&
        pathName != "/contact-us" &&
        pathName != "/about-us" &&
        pathName != "/channelpartner" &&
        !pathName.includes("/thankyou") && (
          <div
            className={`bottomStrip ${
              hideStrip || !showStrip ? "hide-strip" : "showStrip"
            }`}
            id="bottomStrip"
          >
            <div className="bottomStripFlex main-container relative">
              <Link
                href="/projects"
                className="flex-row inner-flex-zero backArrowProject"
              >
                <span className="material-symbols-outlined">chevron_left</span>
              </Link>

              <div className="hidden-xs hidden-sm">
                <div className="section-content">
                  <p className="uppercase gray-color">Projects</p>
                </div>
                <div className="section-paragraph">
                  <p className="capitalize bold-fonts">
                    {projects_full_list_detail.project_title}
                  </p>
                </div>
              </div>

              <div className="bottomSubFlex hidden-xs hidden-sm">
                <div>
                  <div className="section-content">
                    <p className="uppercase gray-color">Type</p>
                  </div>
                  <div className="section-paragraph">
                    <p className="capitalize bold-fonts">
                      {projects_full_list_detail.size_price}
                    </p>
                  </div>
                </div>
                <div>
                  <div className="section-content">
                    <p className="uppercase gray-color">Location</p>
                  </div>
                  <div className="section-paragraph">
                    <p className="capitalize bold-fonts">
                      {projects_full_list_detail.location}
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`bottomEnquirybtn ${isMobilescreen ? "w100" : ""}`}
              >
                <div className="hidden-xs chatBtn">
                  <button
                    className={`reecosys-template-button button-style-secondary ${
                      isMobilescreen ? "w100" : ""
                    }`}
                    onClick={onInquireClick}
                  >
                    <span className="material-symbols-outlined">chat</span>
                    <p className="capitalize">Inquire Now</p>
                  </button>
                </div>

                <div className="w100 arrowBtn">
                  <button
                    className="bottomStripButton reecosys-template-button button-style-secondary w100"
                    onClick={onInquireClick}
                  >
                    <div className="flex-row alc">
                      {/* <span className="bottomInquiryImg">
                        <img
                          src={`${projects_full_list_detail.banners_data?.images?.[0]?.image_web_full}&h=100&w=100&q=100`}
                          alt={projects_full_list_detail.project_title}
                          style={{ borderRadius: "5px" }}
                        />
                      </span> */}
                      <p className="capitalize">Inquire Now</p>
                    </div>
                    <span className="material-symbols-outlined">
                      keyboard_arrow_right
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/918000585555"
        target="_blank"
        rel="noopener noreferrer"
        className={
          isProximityActive || isAmenityActive || inquiryPopup ? "hidden" : ""
        }
      >
        <div
          className={`whatsapp_connect ${
            fixedBtnActive && projects_full_list_detail && isMobilescreen
              ? "active"
              : ""
          }`}
        >
          <div className="whatsapp-icon">
            <img src="/images/icon/Whatsapp.png" alt="Swati Group WhatsApp" />
          </div>
        </div>
      </a>
    </>
  );
};

export default BottomStrip;
